// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mde-header {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  border-bottom: 1px solid #c8ccd0;
  border-radius: 2px 2px 0 0;
  background: #f9f9f9; }
  .mde-header .mde-tabs {
    display: flex;
    flex-direction: row; }
    .mde-header .mde-tabs button {
      border-radius: 2px;
      margin: 6px 3px;
      background-color: transparent;
      border: 1px solid transparent;
      cursor: pointer; }
      .mde-header .mde-tabs button:first-child {
        margin-left: 6px; }
      .mde-header .mde-tabs button.selected {
        border: 1px solid #c8ccd0; }
  .mde-header .svg-icon {
    width: 1em;
    height: 1em;
    display: inline-block;
    font-size: inherit;
    overflow: visible;
    vertical-align: -.125em; }
  .mde-header ul.mde-header-group {
    margin: 0;
    padding: 10px;
    list-style: none;
    display: flex;
    flex-wrap: nowrap; }
    .mde-header ul.mde-header-group.hidden {
      visibility: hidden; }
    .mde-header ul.mde-header-group li.mde-header-item {
      display: inline-block;
      position: relative;
      margin: 0 4px; }
      .mde-header ul.mde-header-group li.mde-header-item button {
        text-align: left;
        cursor: pointer;
        height: 22px;
        padding: 4px;
        margin: 0;
        border: none;
        background: none;
        color: #242729; }

@keyframes tooltip-appear {
  from {
    opacity: 0; }
  to {
    opacity: 1; } }
        .mde-header ul.mde-header-group li.mde-header-item button.tooltipped:hover::before {
          animation-name: tooltip-appear;
          animation-duration: 0.2s;
          animation-delay: 0.5s;
          animation-fill-mode: forwards;
          opacity: 0;
          position: absolute;
          z-index: 1000001;
          width: 0;
          height: 0;
          color: rgba(0, 0, 0, 0.8);
          pointer-events: none;
          content: "";
          border: 5px solid transparent;
          top: -5px;
          right: 50%;
          bottom: auto;
          margin-right: -5px;
          border-top-color: rgba(0, 0, 0, 0.8); }
        .mde-header ul.mde-header-group li.mde-header-item button.tooltipped:hover::after {
          animation-name: tooltip-appear;
          animation-duration: 0.2s;
          animation-delay: 0.5s;
          animation-fill-mode: forwards;
          font-size: 11px;
          opacity: 0;
          position: absolute;
          z-index: 1000000;
          padding: 5px 8px;
          color: #fff;
          pointer-events: none;
          content: attr(aria-label);
          background: rgba(0, 0, 0, 0.8);
          border-radius: 3px;
          right: 50%;
          bottom: 100%;
          transform: translateX(50%);
          margin-bottom: 5px;
          white-space: nowrap; }

.mde-textarea-wrapper {
  position: relative; }
  .mde-textarea-wrapper textarea.mde-text {
    width: 100%;
    border: 0;
    padding: 10px;
    vertical-align: top;
    resize: vertical;
    overflow-y: auto; }

.mde-preview .mde-preview-content {
  padding: 10px; }
  .mde-preview .mde-preview-content p, .mde-preview .mde-preview-content blockquote, .mde-preview .mde-preview-content ul, .mde-preview .mde-preview-content ol, .mde-preview .mde-preview-content dl, .mde-preview .mde-preview-content table, .mde-preview .mde-preview-content pre {
    margin-top: 0;
    margin-bottom: 16px; }
  .mde-preview .mde-preview-content h1, .mde-preview .mde-preview-content h2, .mde-preview .mde-preview-content h3 {
    margin-top: 24px;
    margin-bottom: 16px;
    font-weight: 600;
    line-height: 1.25;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.3em; }
  .mde-preview .mde-preview-content h1 {
    font-size: 1.6em; }
  .mde-preview .mde-preview-content h2 {
    font-size: 1.4em; }
  .mde-preview .mde-preview-content h3 {
    font-size: 1.2em; }
  .mde-preview .mde-preview-content ul, .mde-preview .mde-preview-content ol {
    padding-left: 2em; }
  .mde-preview .mde-preview-content blockquote {
    margin-left: 0;
    padding: 0 1em;
    color: #777;
    border-left: 0.25em solid #ddd; }
    .mde-preview .mde-preview-content blockquote > :first-child {
      margin-top: 0; }
    .mde-preview .mde-preview-content blockquote > :last-child {
      margin-bottom: 0; }
  .mde-preview .mde-preview-content code {
    padding: 0.2em 0 0.2em 0;
    margin: 0;
    font-size: 90%;
    background-color: rgba(0, 0, 0, 0.04);
    border-radius: 3px; }
    .mde-preview .mde-preview-content code::before, .mde-preview .mde-preview-content code::after {
      letter-spacing: -0.2em;
      content: "\\00a0"; }
  .mde-preview .mde-preview-content pre {
    padding: 16px;
    overflow: auto;
    font-size: 85%;
    line-height: 1.45;
    background-color: #f7f7f7;
    border-radius: 3px; }
    .mde-preview .mde-preview-content pre code {
      display: inline;
      padding: 0;
      margin: 0;
      overflow: visible;
      line-height: inherit;
      word-wrap: normal;
      background-color: transparent;
      border: 0; }
      .mde-preview .mde-preview-content pre code::before, .mde-preview .mde-preview-content pre code::after {
        content: none; }
    .mde-preview .mde-preview-content pre > code {
      padding: 0;
      margin: 0;
      font-size: 100%;
      word-break: normal;
      white-space: pre;
      background: transparent;
      border: 0; }
  .mde-preview .mde-preview-content a {
    color: #4078c0;
    text-decoration: none; }
    .mde-preview .mde-preview-content a:hover {
      text-decoration: underline; }
  .mde-preview .mde-preview-content > *:first-child {
    margin-top: 0 !important; }
  .mde-preview .mde-preview-content > *:last-child {
    margin-bottom: 0 !important; }
  .mde-preview .mde-preview-content::after {
    display: table;
    clear: both;
    content: ""; }
  .mde-preview .mde-preview-content table {
    display: block;
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse; }
    .mde-preview .mde-preview-content table thead th {
      font-weight: bold; }
    .mde-preview .mde-preview-content table th, .mde-preview .mde-preview-content table td {
      padding: 6px 13px;
      border: 1px solid #c8ccd0; }

.react-mde {
  border: 1px solid #c8ccd0;
  border-radius: 2px; }
  .react-mde * {
    box-sizing: border-box; }
  .react-mde .invisible {
    display: none; }
  .react-mde .image-tip {
    user-select: none;
    display: flex !important;
    padding: 7px 10px;
    margin: 0;
    font-size: 13px;
    line-height: 16px;
    color: gray;
    background-color: #f9f9f9;
    border-top: 1px solid #c8ccd0;
    position: relative; }
    .react-mde .image-tip .image-input {
      min-height: 0;
      opacity: .01;
      width: 100% !important;
      position: absolute;
      top: 0;
      left: 0;
      padding: 5px;
      cursor: pointer; }

ul.mde-suggestions {
  position: absolute;
  min-width: 180px;
  padding: 0;
  margin: 20px 0 0;
  list-style: none;
  cursor: pointer;
  background: #fff;
  border: 1px solid #c8ccd0;
  border-radius: 3px;
  box-shadow: 0 1px 5px rgba(27, 31, 35, 0.15); }
  ul.mde-suggestions li {
    padding: 4px 8px;
    border-bottom: 1px solid #e1e4e8; }
    ul.mde-suggestions li:first-child {
      border-top-left-radius: 2px;
      border-top-right-radius: 2px; }
    ul.mde-suggestions li:last-child {
      border-bottom-right-radius: 2px;
      border-bottom-left-radius: 2px; }
    ul.mde-suggestions li:hover, ul.mde-suggestions li[aria-selected=true] {
      color: white;
      background-color: #0366d6; }
`, "",{"version":3,"sources":["webpack://./node_modules/react-mde/lib/styles/css/react-mde-all.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,0BAA0B;EAC1B,mBAAmB,EAAE;EACrB;IACE,aAAa;IACb,mBAAmB,EAAE;IACrB;MACE,kBAAkB;MAClB,eAAe;MACf,6BAA6B;MAC7B,6BAA6B;MAC7B,eAAe,EAAE;MACjB;QACE,gBAAgB,EAAE;MACpB;QACE,yBAAyB,EAAE;EACjC;IACE,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB,EAAE;EAC3B;IACE,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,iBAAiB,EAAE;IACnB;MACE,kBAAkB,EAAE;IACtB;MACE,qBAAqB;MACrB,kBAAkB;MAClB,aAAa,EAAE;MACf;QACE,gBAAgB;QAChB,eAAe;QACf,YAAY;QACZ,YAAY;QACZ,SAAS;QACT,YAAY;QACZ,gBAAgB;QAChB,cAAc,EAAE;;AAExB;EACE;IACE,UAAU,EAAE;EACd;IACE,UAAU,EAAE,EAAE;QACV;UACE,8BAA8B;UAC9B,wBAAwB;UACxB,qBAAqB;UACrB,6BAA6B;UAC7B,UAAU;UACV,kBAAkB;UAClB,gBAAgB;UAChB,QAAQ;UACR,SAAS;UACT,yBAAyB;UACzB,oBAAoB;UACpB,WAAW;UACX,6BAA6B;UAC7B,SAAS;UACT,UAAU;UACV,YAAY;UACZ,kBAAkB;UAClB,oCAAoC,EAAE;QACxC;UACE,8BAA8B;UAC9B,wBAAwB;UACxB,qBAAqB;UACrB,6BAA6B;UAC7B,eAAe;UACf,UAAU;UACV,kBAAkB;UAClB,gBAAgB;UAChB,gBAAgB;UAChB,WAAW;UACX,oBAAoB;UACpB,yBAAyB;UACzB,8BAA8B;UAC9B,kBAAkB;UAClB,UAAU;UACV,YAAY;UACZ,0BAA0B;UAC1B,kBAAkB;UAClB,mBAAmB,EAAE;;AAE/B;EACE,kBAAkB,EAAE;EACpB;IACE,WAAW;IACX,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB,EAAE;;AAEtB;EACE,aAAa,EAAE;EACf;IACE,aAAa;IACb,mBAAmB,EAAE;EACvB;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,qBAAqB,EAAE;EACzB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,gBAAgB,EAAE;EACpB;IACE,iBAAiB,EAAE;EACrB;IACE,cAAc;IACd,cAAc;IACd,WAAW;IACX,8BAA8B,EAAE;IAChC;MACE,aAAa,EAAE;IACjB;MACE,gBAAgB,EAAE;EACtB;IACE,wBAAwB;IACxB,SAAS;IACT,cAAc;IACd,qCAAqC;IACrC,kBAAkB,EAAE;IACpB;MACE,sBAAsB;MACtB,gBAAgB,EAAE;EACtB;IACE,aAAa;IACb,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB,EAAE;IACpB;MACE,eAAe;MACf,UAAU;MACV,SAAS;MACT,iBAAiB;MACjB,oBAAoB;MACpB,iBAAiB;MACjB,6BAA6B;MAC7B,SAAS,EAAE;MACX;QACE,aAAa,EAAE;IACnB;MACE,UAAU;MACV,SAAS;MACT,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,uBAAuB;MACvB,SAAS,EAAE;EACf;IACE,cAAc;IACd,qBAAqB,EAAE;IACvB;MACE,0BAA0B,EAAE;EAChC;IACE,wBAAwB,EAAE;EAC5B;IACE,2BAA2B,EAAE;EAC/B;IACE,cAAc;IACd,WAAW;IACX,WAAW,EAAE;EACf;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,yBAAyB,EAAE;IAC3B;MACE,iBAAiB,EAAE;IACrB;MACE,iBAAiB;MACjB,yBAAyB,EAAE;;AAEjC;EACE,yBAAyB;EACzB,kBAAkB,EAAE;EACpB;IACE,sBAAsB,EAAE;EAC1B;IACE,aAAa,EAAE;EACjB;IACE,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;IACjB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB,EAAE;IACpB;MACE,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,YAAY;MACZ,eAAe,EAAE;;AAEvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C,EAAE;EAC9C;IACE,gBAAgB;IAChB,gCAAgC,EAAE;IAClC;MACE,2BAA2B;MAC3B,4BAA4B,EAAE;IAChC;MACE,+BAA+B;MAC/B,8BAA8B,EAAE;IAClC;MACE,YAAY;MACZ,yBAAyB,EAAE","sourcesContent":[".mde-header {\n  flex-shrink: 0;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  border-bottom: 1px solid #c8ccd0;\n  border-radius: 2px 2px 0 0;\n  background: #f9f9f9; }\n  .mde-header .mde-tabs {\n    display: flex;\n    flex-direction: row; }\n    .mde-header .mde-tabs button {\n      border-radius: 2px;\n      margin: 6px 3px;\n      background-color: transparent;\n      border: 1px solid transparent;\n      cursor: pointer; }\n      .mde-header .mde-tabs button:first-child {\n        margin-left: 6px; }\n      .mde-header .mde-tabs button.selected {\n        border: 1px solid #c8ccd0; }\n  .mde-header .svg-icon {\n    width: 1em;\n    height: 1em;\n    display: inline-block;\n    font-size: inherit;\n    overflow: visible;\n    vertical-align: -.125em; }\n  .mde-header ul.mde-header-group {\n    margin: 0;\n    padding: 10px;\n    list-style: none;\n    display: flex;\n    flex-wrap: nowrap; }\n    .mde-header ul.mde-header-group.hidden {\n      visibility: hidden; }\n    .mde-header ul.mde-header-group li.mde-header-item {\n      display: inline-block;\n      position: relative;\n      margin: 0 4px; }\n      .mde-header ul.mde-header-group li.mde-header-item button {\n        text-align: left;\n        cursor: pointer;\n        height: 22px;\n        padding: 4px;\n        margin: 0;\n        border: none;\n        background: none;\n        color: #242729; }\n\n@keyframes tooltip-appear {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n        .mde-header ul.mde-header-group li.mde-header-item button.tooltipped:hover::before {\n          animation-name: tooltip-appear;\n          animation-duration: 0.2s;\n          animation-delay: 0.5s;\n          animation-fill-mode: forwards;\n          opacity: 0;\n          position: absolute;\n          z-index: 1000001;\n          width: 0;\n          height: 0;\n          color: rgba(0, 0, 0, 0.8);\n          pointer-events: none;\n          content: \"\";\n          border: 5px solid transparent;\n          top: -5px;\n          right: 50%;\n          bottom: auto;\n          margin-right: -5px;\n          border-top-color: rgba(0, 0, 0, 0.8); }\n        .mde-header ul.mde-header-group li.mde-header-item button.tooltipped:hover::after {\n          animation-name: tooltip-appear;\n          animation-duration: 0.2s;\n          animation-delay: 0.5s;\n          animation-fill-mode: forwards;\n          font-size: 11px;\n          opacity: 0;\n          position: absolute;\n          z-index: 1000000;\n          padding: 5px 8px;\n          color: #fff;\n          pointer-events: none;\n          content: attr(aria-label);\n          background: rgba(0, 0, 0, 0.8);\n          border-radius: 3px;\n          right: 50%;\n          bottom: 100%;\n          transform: translateX(50%);\n          margin-bottom: 5px;\n          white-space: nowrap; }\n\n.mde-textarea-wrapper {\n  position: relative; }\n  .mde-textarea-wrapper textarea.mde-text {\n    width: 100%;\n    border: 0;\n    padding: 10px;\n    vertical-align: top;\n    resize: vertical;\n    overflow-y: auto; }\n\n.mde-preview .mde-preview-content {\n  padding: 10px; }\n  .mde-preview .mde-preview-content p, .mde-preview .mde-preview-content blockquote, .mde-preview .mde-preview-content ul, .mde-preview .mde-preview-content ol, .mde-preview .mde-preview-content dl, .mde-preview .mde-preview-content table, .mde-preview .mde-preview-content pre {\n    margin-top: 0;\n    margin-bottom: 16px; }\n  .mde-preview .mde-preview-content h1, .mde-preview .mde-preview-content h2, .mde-preview .mde-preview-content h3 {\n    margin-top: 24px;\n    margin-bottom: 16px;\n    font-weight: 600;\n    line-height: 1.25;\n    border-bottom: 1px solid #eee;\n    padding-bottom: 0.3em; }\n  .mde-preview .mde-preview-content h1 {\n    font-size: 1.6em; }\n  .mde-preview .mde-preview-content h2 {\n    font-size: 1.4em; }\n  .mde-preview .mde-preview-content h3 {\n    font-size: 1.2em; }\n  .mde-preview .mde-preview-content ul, .mde-preview .mde-preview-content ol {\n    padding-left: 2em; }\n  .mde-preview .mde-preview-content blockquote {\n    margin-left: 0;\n    padding: 0 1em;\n    color: #777;\n    border-left: 0.25em solid #ddd; }\n    .mde-preview .mde-preview-content blockquote > :first-child {\n      margin-top: 0; }\n    .mde-preview .mde-preview-content blockquote > :last-child {\n      margin-bottom: 0; }\n  .mde-preview .mde-preview-content code {\n    padding: 0.2em 0 0.2em 0;\n    margin: 0;\n    font-size: 90%;\n    background-color: rgba(0, 0, 0, 0.04);\n    border-radius: 3px; }\n    .mde-preview .mde-preview-content code::before, .mde-preview .mde-preview-content code::after {\n      letter-spacing: -0.2em;\n      content: \"\\00a0\"; }\n  .mde-preview .mde-preview-content pre {\n    padding: 16px;\n    overflow: auto;\n    font-size: 85%;\n    line-height: 1.45;\n    background-color: #f7f7f7;\n    border-radius: 3px; }\n    .mde-preview .mde-preview-content pre code {\n      display: inline;\n      padding: 0;\n      margin: 0;\n      overflow: visible;\n      line-height: inherit;\n      word-wrap: normal;\n      background-color: transparent;\n      border: 0; }\n      .mde-preview .mde-preview-content pre code::before, .mde-preview .mde-preview-content pre code::after {\n        content: none; }\n    .mde-preview .mde-preview-content pre > code {\n      padding: 0;\n      margin: 0;\n      font-size: 100%;\n      word-break: normal;\n      white-space: pre;\n      background: transparent;\n      border: 0; }\n  .mde-preview .mde-preview-content a {\n    color: #4078c0;\n    text-decoration: none; }\n    .mde-preview .mde-preview-content a:hover {\n      text-decoration: underline; }\n  .mde-preview .mde-preview-content > *:first-child {\n    margin-top: 0 !important; }\n  .mde-preview .mde-preview-content > *:last-child {\n    margin-bottom: 0 !important; }\n  .mde-preview .mde-preview-content::after {\n    display: table;\n    clear: both;\n    content: \"\"; }\n  .mde-preview .mde-preview-content table {\n    display: block;\n    width: 100%;\n    border-spacing: 0;\n    border-collapse: collapse; }\n    .mde-preview .mde-preview-content table thead th {\n      font-weight: bold; }\n    .mde-preview .mde-preview-content table th, .mde-preview .mde-preview-content table td {\n      padding: 6px 13px;\n      border: 1px solid #c8ccd0; }\n\n.react-mde {\n  border: 1px solid #c8ccd0;\n  border-radius: 2px; }\n  .react-mde * {\n    box-sizing: border-box; }\n  .react-mde .invisible {\n    display: none; }\n  .react-mde .image-tip {\n    user-select: none;\n    display: flex !important;\n    padding: 7px 10px;\n    margin: 0;\n    font-size: 13px;\n    line-height: 16px;\n    color: gray;\n    background-color: #f9f9f9;\n    border-top: 1px solid #c8ccd0;\n    position: relative; }\n    .react-mde .image-tip .image-input {\n      min-height: 0;\n      opacity: .01;\n      width: 100% !important;\n      position: absolute;\n      top: 0;\n      left: 0;\n      padding: 5px;\n      cursor: pointer; }\n\nul.mde-suggestions {\n  position: absolute;\n  min-width: 180px;\n  padding: 0;\n  margin: 20px 0 0;\n  list-style: none;\n  cursor: pointer;\n  background: #fff;\n  border: 1px solid #c8ccd0;\n  border-radius: 3px;\n  box-shadow: 0 1px 5px rgba(27, 31, 35, 0.15); }\n  ul.mde-suggestions li {\n    padding: 4px 8px;\n    border-bottom: 1px solid #e1e4e8; }\n    ul.mde-suggestions li:first-child {\n      border-top-left-radius: 2px;\n      border-top-right-radius: 2px; }\n    ul.mde-suggestions li:last-child {\n      border-bottom-right-radius: 2px;\n      border-bottom-left-radius: 2px; }\n    ul.mde-suggestions li:hover, ul.mde-suggestions li[aria-selected=true] {\n      color: white;\n      background-color: #0366d6; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
